import { Role } from '~/types/user'

type RouteAccessRule = {
  pattern: RegExp
  role?: Role
}

const ROUTE_ACCESS_RULES: RouteAccessRule[] = [
  { pattern: /^\/admin/, role: Role.ADMIN },
  { pattern: /^\/ng-words/, role: Role.ADMIN },
  { pattern: /^\/category-applications/, role: Role.ADMIN },
  { pattern: /^\/category-requests/, role: Role.ADMIN },
  { pattern: /^\/service-packages/, role: Role.ADMIN },
  { pattern: /^\/skills/, role: Role.ADMIN },
  { pattern: /^\/schools/, role: Role.ADMIN },
  { pattern: /^\/users/, role: Role.ADMIN },
]

export function getRouteAccess(pathname: string): RouteAccessRule | undefined {
  return ROUTE_ACCESS_RULES.find((rule) => rule.pattern.test(pathname))
}
